<template>
  <div>
    <Head title="Usuarios" />
    <h1 class="mb-8 text-3xl font-bold">Usuarios</h1>
    <div class="flex flex-wrap items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full mb-2 md:mb-0 max-w-md" @reset="reset">
        <label class="block text-gray-700">Perfil:</label>
        <select v-model="form.role_id" class="form-select mt-1 w-full">
          <option :value="null">Todos</option>
          <option value="1">Administrador</option>
          <option value="2">Consultor</option>
          <option value="3">Usuario</option>
        </select>
        <label class="block mt-4 text-gray-700">Oficinas:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">Activas</option>
          <option value="with">Todas</option>
          <option value="only">Eliminadas</option>
        </select>
      </search-filter>
      <div class="flex">
        <form @submit.prevent="generate">
          <button type="submit" class="btn-indigo">
            <span>Generar</span>
            <span class="hidden md:inline">&nbsp;Usuarios</span>
          </button>
        </form>
        <Link class="btn-orange ml-2" href="/usuarios/crear">
          <span>Crear</span>
          <span class="hidden md:inline">&nbsp;Usuario</span>
        </Link>
      </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Nombre</th>
          <th class="pb-4 pt-6 px-6">Email</th>
          <th class="pb-4 pt-6 px-6">Oficina</th>
          <th class="pb-4 pt-6 px-6" colspan="2">Rol</th>
        </tr>
        <tr v-for="user in users" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-orange-500" :href="`/usuarios/${user.id}/editar`">
              <img v-if="user.photo" class="block -my-2 mr-2 w-5 h-5 rounded-full" :src="user.photo" />
              {{ user.name }}
              <icon v-if="user.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/usuarios/${user.id}/editar`" tabindex="-1">
              {{ user.email }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center flex-wrap px-6 py-4" :href="`/usuarios/${user.id}/editar`" tabindex="-1">
              <span v-for="(organization, index) in user.organizations" :key="index" class="inline-flex items-center px-2.5 my-1 py-0.5 ml-2 rounded-full text-xs font-medium bg-green-100 text-green-800">
                {{ organization.name }}
              </span>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/usuarios/${user.id}/editar`" tabindex="-1">
              {{ user.role.name }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/usuarios/${user.id}/editar`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="users.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No se han encontrado usuarios.</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/usuarios', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    generate() {
      this.$inertia.post('/usuarios/generar')
    },
  },
}
</script>
